// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.loading div {
  position: fixed;
  background: #fff;
  opacity: 1;
  border-radius: 50%;
  z-index: 9999;
  left: 0px;
  top: 0px;
  animation: loading 1.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.loading div:nth-child(2) {
  animation-delay: -0.7s;
}
@keyframes loading {
  0% {
    top: 28px;
    left: 28px;
    width: 0;
    height: 0;
    opacity: 1;
  }
  100% {
    top: -1px;
    left: -1px;
    width: 58px;
    height: 58px;
    opacity: 0;
  }
}

.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100vw;
  height: 100vh;
  background: rgb(255, 255, 255);
  position: fixed;
}
.loader > div {
  width: 20px;
  height: 20px;
  background:#FF712D;
  opacity: 0.5;
  border-radius: 50%;
  margin: 3px;
  animation: loader 0.6s infinite alternate;
}
.loader > div:nth-child(2) {
  animation-delay: 0.2s;
}
.loader > div:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: pink;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Loader/Loader.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,QAAQ;EACR,6DAA6D;AAC/D;AACA;EACE,sBAAsB;AACxB;AACA;EACE;IACE,SAAS;IACT,UAAU;IACV,QAAQ;IACR,SAAS;IACT,UAAU;EACZ;EACA;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;EAClB;AACF","sourcesContent":[".loading {\n  display: inline-block;\n  position: relative;\n  width: 64px;\n  height: 64px;\n}\n.loading div {\n  position: fixed;\n  background: #fff;\n  opacity: 1;\n  border-radius: 50%;\n  z-index: 9999;\n  left: 0px;\n  top: 0px;\n  animation: loading 1.4s cubic-bezier(0, 0.2, 0.8, 1) infinite;\n}\n.loading div:nth-child(2) {\n  animation-delay: -0.7s;\n}\n@keyframes loading {\n  0% {\n    top: 28px;\n    left: 28px;\n    width: 0;\n    height: 0;\n    opacity: 1;\n  }\n  100% {\n    top: -1px;\n    left: -1px;\n    width: 58px;\n    height: 58px;\n    opacity: 0;\n  }\n}\n\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 100vw;\n  height: 100vh;\n  background: rgb(255, 255, 255);\n  position: fixed;\n}\n.loader > div {\n  width: 20px;\n  height: 20px;\n  background:#FF712D;\n  opacity: 0.5;\n  border-radius: 50%;\n  margin: 3px;\n  animation: loader 0.6s infinite alternate;\n}\n.loader > div:nth-child(2) {\n  animation-delay: 0.2s;\n}\n.loader > div:nth-child(3) {\n  animation-delay: 0.4s;\n}\n@keyframes loader {\n  to {\n    opacity: 0.1;\n    transform: translate(0, -20px);\n    background: pink;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
